import { PropsWithChildren, useState } from 'react';

import {
  BuilderCampaignData,
  BuilderCampaignDataContext,
} from '@features/campaigns/builder/providers/BuilderCampaignDataProvider/providerSetup.ts';

export function BuilderCampaignDataProvider({ children }: PropsWithChildren) {
  const [campaignData, setCampaignData] = useState<BuilderCampaignData>({
    campaignId: undefined,
    invalidSections: undefined,
  });

  return (
    <BuilderCampaignDataContext.Provider value={{ campaignData, setCampaignData }}>
      {children}
    </BuilderCampaignDataContext.Provider>
  );
}
